<template>
    <v-dialog
    v-model="show"
    persistent
    width="300">
   
    <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>Combinations</v-toolbar-title>  
                 <v-spacer/>
                   <v-btn x-small fab @click="emitToParent('ok')">
                         X
                    </v-btn>
        </v-toolbar>
          <v-card-text class="pa-4 ">
                <div v-for="(item, index) in combinations" :key="index" class="font-weight-bold">
                  {{ item.combination }}  <strong style="float: right">{{ $money(item.amount) }}</strong>
                  <v-divider v-if="index < combinations.length - 1" class="my-1"></v-divider>
                </div>
          </v-card-text>
          <v-card-actions>
             
              <v-spacer/>
              <v-btn large color="success" text @click="emitToParent('ok')">
                Close
              </v-btn>
          </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      message: {
            type: String,
          default:''
      },
      combinations: {
          type: Array,
          default: () => []
      },

      cancelbtn: {
          type: String,
          default:''
      }
  },
  methods: {
   emitToParent (action) {
      this.$emit('ConfirmEvent', action)
    }
  }
}
</script>
